var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#872bf8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5.5h-12a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1ZM1.5 8.5h12M1.5 11.5h12M1.5 14.5h12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#872bf8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.5 2.5-1 1-1-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d9e4e144e4294d28095f14be9a87f279.svg";
export { ForwardRef as ReactComponent };